
import { FunctionComponent } from 'react';

import './Icon.light.scss';
import './Icon.dark.scss';

/**
 * The icon types can be found on https://fonts.google.com/icons
 */
type IconType =
  | 'open_in_new'
  | 'chevron_left'
  | 'add'
  | 'close'
  | 'check'
  | 'radio_button_unchecked'
  | 'check_box_outline_blank'
  | 'check_box'
  | 'radio_button_checked'
  | 'chevron_right'
  | 'donut_large'
  | 'home'
  | 'info'
  | 'report_problem'
  | 'arrow_back'
  | 'arrow_forward'
  | 'arrow_downward'
  | 'arrow_right'
  | 'arrow_drop_down'
  | 'replay'
  | 'keyboard_double_arrow_left'
  | 'keyboard_double_arrow_right'
  | 'login'
  | 'logout'
  | 'account_circle'
  | 'save'
  | 'history'
  | 'sort'
  | 'image'
  | 'contact_support'
  | 'expand_more'
  | 'expand_less'
  | 'help'
  | 'indeterminate_check_box'
  | 'edit'
  | 'feedback'
  | 'chat'
  | 'send'
  | 'open_in_full'
  | 'close_fullscreen'
  | 'thumb_up'
  | 'thumb_down'
  | 'person'
  | 'lock_reset';

interface Props {
  icon: IconType;
  className?: string;
  style?: 'round' | 'outlined';
  size?: string;
}

export function Icon(props: Props) {
  return (
    <span
      className={`icon material-icons${props.className ? ' ' + props.className : ''}`}
      style={{
        fontFamily: `Material Icons ${props.style === 'round' ? 'Round' : 'Outlined'}`,
        ...(props.size && { fontSize: props.size })
      }}
    >
      {props.icon}
    </span>
  );
}

(Icon as FunctionComponent<Props>).defaultProps = {
  style: 'round'
};
